import { Star } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SHOW_PROMO_BANNER } from "@/config/promoBanner"

export default function MobileAppBanner() {
  return (
    <div className={`md:hidden fixed ${SHOW_PROMO_BANNER ? 'top-[100px]' : 'top-[64px]'} left-0 right-0 z-20 bg-gradient-to-r from-[#f7bbac] to-[#f9bb72] shadow-md rounded-b-2xl`}>
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1">
            <div className="flex items-center gap-1 mb-1">
              {[1, 2, 3, 4].map((i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-white text-white" />
              ))}
              <div className="relative inline-block">
                <Star className="w-3.5 h-3.5 text-white fill-white/20" />
                <div className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
                  <Star className="w-3.5 h-3.5 fill-white text-white" />
                </div>
              </div>
              <span className="text-xs font-semibold text-white ml-1">4,5/5</span>
            </div>
            <p className="text-xs font-medium text-white leading-tight">
              Téléchargez l'app pour créer vos albums !
            </p>
          </div>
          <Button 
            size="sm" 
            variant="secondary"
            className="bg-white text-[#f9bb72] hover:bg-white/90 font-semibold text-xs whitespace-nowrap shadow-md"
            asChild
          >
            <a href="https://www.wememberz.com/applications" target="_blank" rel="noopener noreferrer">Télécharger</a>
          </Button>
        </div>
      </div>
    </div>
  )
}
